const PLAIN_FIELD_TYPES = new Set([
  "url",
  "number",
  "email",
  "boolean",
  "image",
  "video",
  "file",
]);

const PLAIN_KEY_PATTERNS = [
  /slug/i,
  /_link$/i,
  /link$/i,
  /_url$/i,
  /_count$/i,
  /_max$/i,
  /_image$/i,
  /_caption$/i,
  /_platform$/i,
  /_icon$/i,
  /^social_/i,
  /map_image/i,
  /_x$/i,
  /_y$/i,
  /featured_/i,
  /sortorder/i,
  /sort_label/i,
  /apply_form/i,
  /connect_link/i,
  /button_outline_link/i,
  /button_primary_link/i,
  /buttonoutline_link/i,
  /buttonprimary_link/i,
  /button_link/i,
  /buttonlink/i,
  /^email$/i,
  /^phone$/i,
];

const PLAIN_KEY_EXACT = new Set([
  "category",
  "slug",
  "location",
  "type",
  "date",
  "client",
  "sortlabel",
  "list_title",
  "selected_title",
  "connect_link",
  "buttonlink",
]);

function fieldKey(field) {
  if (typeof field === "string") return field.toLowerCase();
  return String(field?.key || "").toLowerCase();
}

export function isPlainOnlyField(field) {
  const type = String(field?.fieldType || "text").toLowerCase();
  if (PLAIN_FIELD_TYPES.has(type)) return true;

  if (field?.isRichText === false) return true;
  if (field?.isRichText === true) return false;

  const key = fieldKey(field);
  if (!key) return false;

  if (PLAIN_KEY_EXACT.has(key)) return true;
  if (key.endsWith("_category")) return true;
  if (key.endsWith("_slug")) return true;
  if (PLAIN_KEY_PATTERNS.some((pattern) => pattern.test(key))) return true;

  return false;
}

export function usesRichTextEditor(field) {
  if (field?.isRichText === true) return true;
  if (field?.isRichText === false) return false;

  const type = String(field?.fieldType || "text").toLowerCase();
  if (isPlainOnlyField(field)) return false;
  if (type === "textarea" || type === "rich-text" || type === "text") return true;
  return false;
}

export function isCompactRichTextField(field) {
  const type = String(field?.fieldType || "text").toLowerCase();
  return type === "text" && usesRichTextEditor(field);
}
